"use client";

import { usePathname } from "next/navigation";
import { ThemeProvider } from "next-themes";
import type { ReactNode } from "react";
import { isProcorePath } from "@/lib/isProcorePath";

export function ThemeProviderClient({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  // The Procore plugin is iframed inside Procore, which doesn't support dark
  // mode. Force light here so a system dark-mode preference doesn't make our
  // panel stand out against Procore's light UI. `forcedTheme` locks the
  // rendered theme without erasing the user's preference for other routes.
  const forcedTheme = isProcorePath(pathname) ? "light" : undefined;
  return (
    <ThemeProvider attribute="class" defaultTheme="light" forcedTheme={forcedTheme}>
      {children}
    </ThemeProvider>
  );
}
